<template>
  <div class="details">
    <div class="details-content flex">
      <div class="details-left">
        <div class="course-info flex aic">
          <div class="course-img ovh por">
            <img :src="courseInfo.bgimg" alt="" class="w100 h100">
            <div class="poa r0 course-tip" v-if="+courseType === 3 ? !courseInfo.is_pay : !userInfo.is_web_vip">
              <label-tip :label-type="courseInfo.is_pay === 1 ? false : courseInfo.type === 1 && userInfo.is_web_vip ? 'false' :  ['','free','vip','pay'][courseInfo.type]" radius-type="9"></label-tip>
            </div>
          </div>
          <div class="lh1 flex-1">
            <div class="fs22 flex aic jcb course-title">
              <span class="vam color_333">{{courseInfo.name | filterTitle}}</span>
              <p @click="changeCollect" class="flex aic csp collection-box">
                <span class="audio-icon collection_icon csp" :class="{'collection_icon_active':courseInfo.is_collection}"></span>
                <span class="fs14 collection-text" :class="courseInfo.is_collection ? 'collection-true' : 'collection-false'">{{courseInfo.is_collection?'已':''}}收藏</span>
              </p>
            </div>
            <div class="color_666 fs16 flex aic">
              <span>主讲教师：</span>
              <p class="csp course-teacher flex aic" v-if="courseInfo.teacher_list">
                <template v-if="courseInfo.teacher_list.length">
                  <span v-for="(teacher,ind) in courseInfo.teacher_list" :key="ind" @click="goTeacherDetail(teacher.id)" class="pr5 dib flex aic">{{teacher.name}}
                    <i class="audio-icon right_arrow dib" v-show="courseInfo.teacher_list.length <= 1"></i>
                  </span>
                </template>
                <template v-else>
                  <span @click="goTeacherDetail(909)">格灵教育
                    <i class="audio-icon right_arrow dib" v-show="courseInfo.teacher_list.length <= 1"></i>
                  </span>
                  
                </template>
              </p>
            </div>
            <p class="color_999 course-label" v-show="courseInfo.label_name">类型：{{courseInfo.label_name}}</p>
            <div class="flex aic color_999 course-total">
              <template v-for="(item,i) in labelList">
                <p :key="i" class="pr25" v-show="item.show"><span class="audio-icon" :class="item.icon"></span><span class="vam">{{item.label}}{{item.value}}{{item.desc}}</span></p>
              </template>
            </div>
            <div class="course-pay flex aic fs12" v-if="courseInfo.is_pay && +courseType === 3">
              <p>课程有效期至：{{courseInfo.past_time}}</p>
              <p class="course-pay-renew csp flex aic" @click="changePay">续费<i class="audio-icon pay_arrow_icon pb2"></i></p>
            </div>
            <div class="flex" :class="{'btn-box': +courseType !== 3 || !courseInfo.is_pay }">
              <p class="btn-play csp tac" @click="changeAudio">
                <span class="audio-icon play_icon" :class="{'pause_icon': !isPlay}"></span>
                <span class="vam">{{isPlay ? '播放' : '暂停'}}</span>
              </p>
              <template v-if="+courseType === 2 && !courseInfo.is_pay">
                <p class="btn-vip csp" @click="openVip"><span class="audio-icon vip_icon"></span><span class="vam">开通会员</span></p>
              </template>
              <template v-else-if="+courseType === 3">
                <template v-if="!courseInfo.is_pay">
                  <!-- 购买前 -->
                  <div class="pay-box por">
                    <p class="pay-btn csp" v-if="!courseInfo.is_activity" @click="changePay">{{userInfo.is_web_vip ? courseInfo.vip_price : courseInfo.price}}元 立即购买</p>
                    <div v-else class="pay-activity flex aic csp" :class="courseInfo.discount ? 'zk-bg':'yh-bg'" @click="changePay">
                      <p class="pay-discount">
                        <span v-if="courseInfo.discount">限时{{courseInfo.discount}}折</span>
                        <span v-else>立减￥{{userInfo.is_web_vip ? (courseInfo.original_vip_price -
                courseInfo.vip_price).toFixed(2) : (courseInfo.original_price - courseInfo.price).toFixed(2)}}</span>
                      </p>
                      <p class="pay-price">
                        <span>￥{{userInfo.is_web_vip ? courseInfo.vip_price : courseInfo.price}}元</span>
                        <s class="fs12">原价￥{{userInfo.is_web_vip ? courseInfo.original_vip_price : courseInfo.original_price}}</s>
                      </p>
                      <i class="audio-icon shop_icon"></i>
                    </div>
                    <div class="poa pay-time w100 tac" v-if="courseInfo.is_activity">
                      <p v-if="!courseInfo.activity_data.surplus_time">距优惠结束：{{Tools.formatDate(courseInfo.activity_data.end_time, 'Y年MM月DD日')}}</p>
                      <p v-else v-html="`距优惠结束：${surplus_time}`"></p>
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class="tabs-box flex aic">
          <p v-for="tab in tabs" :key="tab.id" class="fs18 tabs-item csp" :class="{'tabs-active':currTab === tab.prop}" @click="changeTab(tab)">{{tab.label}}</p>
        </div>
        <!-- 简历 -->
        <div class="introduce ovh" :style="{height:isShowAll || !isShowVertical ? 'auto' : '300px'}" ref="introduce">
          <p class="color_666 introduce-remark">{{courseInfo.remark}}</p>
          <div class="introduce-imgs">
            <img :src="img.show" alt="" v-for="(img,i) in courseInfo.vertical_img" :key="i" class="w100 vam" v-show="img.show">
          </div>
        </div>
        <div class="color_999 tac csp see-box pt10" @click="isShowAll = !isShowAll" v-if="isShowVertical">
          <span class="pr5 vam">{{isShowAll ? '收起' : '查看全部'}}</span>
          <span class="audio-icon bottom_arrow" :class="{'top_arrow': isShowAll}"></span>
        </div>
        <!-- 课时 -->
        <div class="classhour" ref="classhour">
          <template v-if="courseInfo.resource_list && courseInfo.resource_list.data.length">
            <p class="classhour-title color_999 bg">课时名称</p>
            <p v-for="(item,i) in courseInfo.resource_list.data" :key="i" class="bg classhour-item csp wot1" :class="{'classhour-active': classId === item.id}" @click="changeClass(item)">
              <span class="audio-icon classhour-icon dib" :class="{'lock_icon':item.is_pay !== 1 && item.is_free === 1,'play_icon_acitve': classId === item.id}"></span>
              <span class="vam ml10">{{item.name}}</span>
            </p>
          </template>
        </div>
        <df-page :total="total" :page-size="limits" :current="curr" @change="changePage"></df-page>
      </div>
      <div class="details-right flex-1">
        <df-list v-for="(item,i) in rankingList" :key="i" :item="item"></df-list>
      </div>
    </div>
		<offline v-if="!courseInfo.resource_list || !courseInfo.resource_list.data.length" :is-no-data="!courseInfo||!courseInfo.resource_list" show class="no-data"></offline>
  </div>
</template>

<script>
import Mixins from '@/mixins/mixins';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: "AudioDetails",
  mixins: [Mixins.MakeRoute({ cid: 'cid', tab: 'courseType' }, 'params'), Mixins.MakeRoute(['subject_id', 'rid'], 'query')],
  filters: {
    filterTitle (text) {
      text = text ? text.split(/[:：]/) : '';
      return text[1] || text[0];
    },
    filterCount (num) {
      if (num > 10000) {
        return (num / 1000).toFixed(2) + '万'
      } else {
        return num;
      }
    }
  },
  data () {
    return {
      tabs: [
        { id: 1, label: '简介', prop: 'introduce' },
        { id: 2, label: '课时', prop: 'classhour' },
      ],
      currTab: 'introduce', // 当前选中的内容
      recommedList: [],
      likeList: [],
      boutiqueList: [],
      courseInfo: {
        is_pay: 1
      },
      isShowAll: false,
      curr: 1,
      limits: 20,
      total: 0,
      classId: 0, // 课时id
      isShowVertical: false, // 是否有竖版详情图
      isPlay: true, // 是否播放

      audioloading: false,
      surplus_time: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'currAudio']),
    rankingList () {
      return [
        { title: '本月热门推荐', icon: 'icon_1', prop: 'course', list: this.recommedList },
        { title: '猜你喜欢', icon: 'icon_4', prop: 'course', list: this.likeList },
        { title: '精品课程畅销榜', icon: 'icon_3', prop: 'course', list: this.boutiqueList }
      ]
    },
    labelList () {
      return [
        { label: '课时：', value: this.total, icon: 'count_icon', show: true },
        { label: '收听人数：', value: this.courseInfo.hits, icon: 'see_icon', show: !!this.courseInfo.hits, desc: '次' },
        { label: '购买人数：', value: this.courseInfo.buy_num, icon: 'buy_icon', show: +this.courseType === 3 && !!this.courseInfo.buy_num, desc: '人' },
      ]
    },
    audio () {
      return this.currAudio ? this.GetAppAudio() : null;
    },
  },
  watch: {
    $route () {
      this.initData();
    },
    audio (val) {
      if (!this.audioloading && val) {
        this.audioloading = true;
        val.$on('play', this.audioEvent);
        val.$on('pause', this.audioEvent);
        val.$on('save-success', this.changeSave);
        val.$on('get-resource-success',this.getResSuccess);
        val.$on('control-next', this.changeControl);
        val.$on('control-prev', this.changeControl);
        val.isAutoPlay = false; // 取消自动播放
        // if (this.currAudio && +this.currAudio.cid === +this.cid && this.currAudio.isPlay){
        //   val.isAutoPlay = false;
        // }
      }
    }
  },
  created () {
    this.$emit('set-background-color', '#F5FCFF');
    this.initData();
  },
  mounted () {
    document.getElementById('app').addEventListener('scroll', this.scrollCallback);
  },
  destroyed () {
    document.getElementById('app').removeEventListener("scroll", this.scrollCallback);
  },
  methods: {
    ...mapMutations(['setCurrAudio']),
    initData () {
      // if(+this.rid){
      //   this.classId = +this.rid;
      // } else if (this.currAudio && +this.currAudio.cid === +this.cid) {
      //   this.classId = +this.currAudio.rid;
      //   this.$nextTick(() => {
      //     this.isPlay = this.audio ? !this.audio.playing : true;
      //   })
      // } else {
      //   this.isPlay = true;
      // }
      this.getCourseDetail();
      this.getRankingList();
    },
    scrollCallback (e) {
      if (e.target.scrollTop < (this.$refs.classhour.offsetTop - 100)) {
        this.currTab = 'introduce';
      } else {
        this.currTab = 'classhour';
      }
    },
    changeControl(){
      if(this.audio){
        this.audio.isAutoPlay = true;
      }
    },
    getResSuccess(info){
      this.classId = info.id;
      +this.rid &&  (this.rid = info.id);
    },
    // 获取课程详情
    getCourseDetail () {
      let { cid, userInfo, Product, curr, limits } = this;
      let params = {
        course_id: cid,
        uid: userInfo.uid,
        is_new: 1,
        channel_type: 2,
        ...Product,
        curr,
        limits,
        is_web: 1
      };
      this.http.getResourceList(params).then(res => {
        document.title = this.$options.filters['filterTitle'](res.name);
        this.courseInfo = res;
        this.total = res.resource_list.total;
        this.isShowVertical = !!res.vertical_img.find(e => e.show);
        if (res.activity_data && res.activity_data.surplus_time && res.is_activity && !this.surplus_time) {
          this.ActivityCountDown(res.activity_data.surplus_time * 1000, { key: 'surplus_time', format: 'DD天HH时mm分ss秒', style: 'color:rgba(0, 15, 34, 0.7);' }, () => { this.getCourseDetail(); });
        }
        let item = res.resource_list.data.find(r => r.id === +this.rid);
        if(+this.rid && item && +item.is_pay === 1){
          this.setCurrAudio({ cid: this.cid, rid: this.rid, type: this.courseType });
        } else if ((this.currAudio && +this.currAudio.cid !== +cid) || !this.currAudio) {
          // let rid = res.resource_id ? res.resource_id : res.resource_list.data[0].id;
          // this.classId = rid;
          this.setCurrAudio({ cid: this.cid, rid: res.resource_list.data[0].id, type: this.courseType });
        }else {
          if(curr !== 1 && +this.currAudio.cid){
            return;
          }
          let isPay = res.resource_list.data.find(r => r.id === +this.currAudio.rid);
          let id = isPay && isPay.is_pay === 1 ? +this.currAudio.rid : res.resource_list.data[0].id;
          this.setCurrAudio({ cid: this.cid, rid: id, type: this.courseType });
        }
        this.getLikeList();
      }).catch((error)=>{
				  if (+error.code === 20011) {
				    this.ShowToast('该课程已下架，请观看其他课程');
				    setTimeout(() => { window.close() }, 2500);
						return false
				  }
				  this.$err(error);
			});
    },
		//获取课程信息
		async checkClassState(){
			let { cid, userInfo, Product, curr, limits } = this;
			let params = {
			  course_id: cid,
			  uid: userInfo.uid,
			  is_new: 1,
			  channel_type: 2,
			  ...Product,
			  curr:1,
			  limits:1,
			  is_web: 1
			};
			let res = await this.http.getResourceList(params);
			// console.log(res)
			return res;
		},
    async changePay () {
			try{
			  let res = await this.checkClassState();
				this.ShowVip({ type: 'pay', cid: this.cid });
			} catch (error) {
			  if (+error.code === 20011) {
			    this.ShowToast('该课程已下架，请观看其他课程');
			    setTimeout(() => { window.close() }, 2500);
					return false
			  }
			  // this.$err(error);
			}
      // this.ShowVip({ type: 'pay', cid: this.cid });
    },
    // 分页
    changePage (value) {
      this.curr = value;
      this.getCourseDetail();
    },
    audioEvent (audio) {
      this.isPlay = !this.audio.playing;
    },
    // 选择课时
    changeClass (item) {
      if (item.id === this.classId) { return; }
      if (this.userInfo.is_web_vip && item.is_pay !== 1 && +this.courseType === 2) {
        return this.ShowGift({ type: 'no-power', formatiId: 2 });
      }
      if (item.is_pay !== 1 && item.is_free === 1) {
				let type = +this.courseType === 3 ? 'pay' : 'open-vip'
        return this.ShowGift({ type: type , cid: this.cid ,'check-class':()=>{
								// 拦截当用户在详情页面的时候未购买的付费课程下架了点击续费能弹出购买页面
								this.$nextTick(async ()=>{
									try{
									  let res = await this.checkClassState();
										if(+this.courseType === 3){
											this.ShowVip({ type: 'pay', cid: this.cid });
										}
									} catch (error) {
									  if (+error.code === 20011) {
									    this.ShowToast('该课程已下架，请观看其他课程');
									    setTimeout(() => { window.close() }, 2500);
											return false
									  }
									  // this.$err(error);
									}
								}) 
							},stop:+this.courseType === 3});
      }
      this.classId = item.id;
      this.audio.isAutoPlay = true;
      this.setCurrAudio({ cid: this.cid, rid: item.id, type: this.courseType });
    },
    // 选择简介/课时
    changeTab (item) {
      this.currTab = item.prop;
      let num = this.currTab === 'classhour' ? 100 : 130;
      let offsetTop = this.$refs[this.currTab].offsetTop - num;
      document.getElementById('app').scrollTop = offsetTop;
    },
    // 控制播放或暂停
    changeAudio () {
      this.isPlay = !this.isPlay;
      if (this.audio) {
        this.audio.ctrlCb('play');
      }
    },
    // 开通会员
    openVip () {
      this.ShowVip();
    },
    changeSave (statue) {
      Object.assign(this.courseInfo, { 'is_collection': statue });
    },
    // 课程收藏
    changeCollect () {
      if (!this.userInfo.uid) {
        return this.ShowToast('要登录之后才能收藏课程!');
      }
      this.http.saveCourseCollection({ uid: this.userInfo.uid, course_id: this.cid, ...this.Product, product_id: 13 }).then(res => {
        this.ShowToast(res.status === 1 ? '收藏成功' : '取消收藏');
        this.courseInfo.is_collection = res.status === 1 ? 1 : 0;
        this.audio.resourceInfo.is_collection = this.courseInfo.is_collection;
      }).catch(this.$err);
    },
    // 跳转老师详情页
    goTeacherDetail (id) {
      this.OpenRouter(`/home/teacher/detail/${id}`);
    },
    // 获取榜单
    async getRankingList () {
      let params = {
        ...this.Product,
        is_web: 1
      };
      await Promise.all([
        this.http.NEWCoursePlayRanking({ format_id: 1, ...params }).then(r => { this.recommedList = r.list }),
        this.http.NEWCoursePayRanking(params).then(r => { this.boutiqueList = r.list }),
      ]).catch(this.$err);
    },
    // 获取猜你喜欢列表课程
    getLikeList () {
      if (this.subject_id || this.courseInfo.label_id) {
        let params = {
          course_id: this.cid,
          subject_id: this.subject_id,
          label_id: this.courseInfo.label_id,
          ...this.Product
        };
        this.http.NEWSubjectCourse(params).then(r => { this.likeList = r.list }).catch(this.$err);
      }
    }
  },
}
</script>

<style scoped lang="less">
@import '../../../../../assets/less/function.less';

@act-color: #1177ff;

.audio-icon {
  .spirit(url(../../../../../assets/images/audio_icon.png));
  &.collection_icon {
    margin-left: 32px;
    &:after {
      width: 28px;
      height: 28px;
      background-position: -2px -2px;
    }
  }
  &.collection_icon_active {
    &:after {
      background-position: -62px -2px;
    }
  }
  &.play_icon {
    margin-right: 6px;
    &:after {
      width: 12px;
      height: 14px;
      background-position: -151px -3px;
    }
  }
  &.pause_icon {
    margin-right: 7px;
    &:after {
      width: 12px;
      height: 13px;
      background-position: -168px -4px;
    }
  }
  &.count_icon {
    margin-right: 4px;
    &:after {
      width: 22px;
      height: 22px;
      background-position: -185px -1px;
    }
  }
  &.see_icon {
    margin-right: 4px;
    &:after {
      width: 22px;
      height: 22px;
      background-position: -209px -1px;
    }
  }
  &.buy_icon {
    margin-right: 4px;
    &:after {
      width: 22px;
      height: 22px;
      background-position: -383px -31px;
    }
  }
  &.vip_icon {
    margin-right: 6px;
    &:after {
      width: 18px;
      height: 18px;
      background-position: -294px -1px;
    }
  }
  &.right_arrow {
    margin-left: 9px;
    height: 14px;
    &:after {
      width: 8px;
      height: 14px;
      vertical-align: top;
      background-position: -125px -2px;
    }
  }
  &.right_arrow_hover {
    &:after {
      background-position: -136px -2px;
    }
  }
  &.bottom_arrow {
    &:after {
      width: 14px;
      height: 8px;
      background-position: -232px -3px;
    }
  }
  &.bottom_arrow_hover {
    &:after {
      background-position: -247px -3px;
    }
  }
  &.top_arrow {
    &:after {
      width: 14px;
      height: 8px;
      background-position: -262px -3px;
    }
  }
  &.top_arrow_hover {
    &:after {
      background-position: -277px -3px;
    }
  }
  &.play_icon_acitve {
    &:after {
      width: 16px;
      height: 16px;
      background-position: -313px -1px;
    }
  }
  &.lock_icon {
    &:after {
      width: 16px;
      height: 16px;
      background-position: -330px -1px;
    }
  }
  &.shop_icon {
    padding-right: 16px;
    &:after {
      width: 19px;
      height: 17px;
      background-position: -413px -34px;
    }
  }
  &.pay_arrow_icon {
    padding-left: 7px;
    &:after {
      width: 5px;
      height: 9px;
      background-position: -424px -17px;
    }
  }
}

.details {
  &-content {
    padding: 24px 0 48px;
  }
  &-left {
    width: 844px;
    background: #ffffff;
    border-radius: 8px;
    padding: 32px;
    /deep/ .page-box {
      padding: 64px 0 32px;
    }
  }
  &-right {
    padding-left: 16px;
  }
  .course {
    &-pay {
      padding: 13px 0 15px;
      color: #825215;
      &-renew {
        padding-left: 18px;
      }
    }
    &-title {
      padding-bottom: 18px;
    }
    &-total {
      padding-top: 18px;
    }
    &-label {
      padding-top: 18px;
    }
    &-tip {
      top: 8px;
    }
    &-info {
      padding-bottom: 23px;
    }
    &-img {
      width: 180px;
      height: 206px;
      border-radius: 8px;
      margin-right: 24px;
    }
    &-teacher {
      &:hover {
        color: @act-color;
        .right_arrow {
          .audio-icon .right_arrow_hover;
        }
      }
    }
  }
  .collection-box {
    &:hover {
      .collection_icon {
        &:after {
          background-position: -32px -2px;
        }
      }
      .collection_icon_active {
        &:after {
          background-position: -92px -2px;
        }
      }
      .collection-true {
        color: #d8b30f;
      }
      .collection-false {
        color: #f0cb25;
      }
    }
  }
  .collection-text {
    padding-left: 6px;
    color: #8d9299;
  }
  .collection-true {
    color: #f0cb25;
  }
  .btn {
    &-box {
      padding-top: 45px;
    }
    &-play {
      width: 84px;
      padding: 8px 18px;
      background: #1177ff;
      border-radius: 16px;
      font-weight: bold;
      color: #ffffff;
      &:hover {
        background: #0066ed;
      }
    }
    &-vip {
      margin-left: 16px;
      padding: 0 18px;
      height: 32px;
      line-height: 32px;
      background: linear-gradient(-45deg, #ffd28c, #ffd99e);
      border-radius: 16px;
      font-weight: bold;
      color: #b9732e;
      &:hover {
        background: #ffdfad;
      }
    }
  }
  .pay {
    &-box {
      margin-left: 16px;
      &:not(.pay-time):hover {
        .zk-bg {
          background: #f24f1b;
        }
        .yh-bg {
          background: #f7274d;
        }
        .pay-btn {
          background: #ffe556;
        }
      }
    }
    &-btn {
      padding: 9px 29px;
      background: linear-gradient(135deg, #fff177, #ffe86a);
      border-radius: 16px;
      color: #825215;
    }
    &-activity {
      height: 32px;
      border-radius: 16px;
    }
    &-discount {
      padding: 9.5px 21.5px;
      background: #ffe8c0;
      border-radius: 16px;
      font-weight: bold;
      color: #a56f2b;
    }
    &-price {
      color: #ffffff;
      padding: 0 28px 0 24px;
      span {
        padding-right: 11px;
      }
    }
    &-time {
      color: rgba(153, 159, 166, 0.7);
      bottom: -21px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .zk-bg {
    background: linear-gradient(90deg, #ff8526, #ff5924);
  }
  .yh-bg {
    background: linear-gradient(90deg, #ff4768, #ff375c);
  }
  .tabs {
    &-box {
      border-bottom: 1px solid #eeeeee;
      position: sticky;
      top: 65px;
      background-color: #fff;
    }
    &-item {
      padding: 17px 0;
      margin-right: 30px;
      position: relative;
      .color_666;
      &:hover {
        color: @act-color;
      }
    }
    &-active {
      color: @act-color;
      &::before {
        content: '';
        width: 23px;
        height: 3px;
        background: #1177ff;
        border-radius: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .introduce {
    padding-top: 30px;
    transition: height 0.3s;
    &-remark {
      line-height: 22px;
      text-indent: 20px;
      padding-bottom: 23px;
    }
    &-imgs {
      margin: 0 auto;
      width: 754px;
    }
  }
  .see-box {
    &:hover {
      color: @act-color;
      .bottom_arrow {
        .audio-icon .bottom_arrow_hover;
      }
      .top_arrow {
        .audio-icon .top_arrow_hover;
      }
    }
  }
  .classhour {
    padding-top: 34px;
    &-title {
      padding-left: 103px;
    }
    &-item {
      .color_333;
      padding-left: 48px;
      &:not(.classhour-active):hover {
        color: @act-color;
      }
    }
    &-active {
      color: @act-color;
    }
    .bg {
      height: 50px;
      line-height: 50px;
      &:nth-child(2n-1) {
        background: #f5f7fb;
        border-radius: 4px 4px 0px 0px;
      }
    }
    &-icon {
      width: 16px;
    }
  }
  .color_333 {
    color: #333f4e;
  }
  .color_666 {
    color: #666f7a;
  }
  .color_999 {
    color: #999fa6;
  }
}
</style>